export const wizardInfo = [
  {
    hero: 'What type of video are you looking to create?',
    subtext: 'Select the one that applies.',
    key: 'type',
    name: 'Type',
    isMultiple: false,
    cardSelected: [],
    questionResponse: [],
    description: '',
    cards: [
      {
        label: 'Ad',
        text:
        'Direct Response, Brand Awareness, Consideration, etc',
        isCardSelected: false,
        value: 'social_digital_ad',
        Lengths: 'Lengths: :06-, :15-, :30- or 60 seconds',
      },
      {
        label: 'Animated Explainers',
        text: 'How-To, Product walkthrough, Recipe',
        isCardSelected: false,
        value: 'explainers',
        Lengths: 'Lengths: typically up to 2 minutes',
      },
      // {
      //   label: ' Static to Video',
      //   text: 'Videos created entirely from static or still images',
      //   isCardSelected: false,
      //   value: 'online_course',
      //   Lengths: 'typically up to 90 seconds',
      // },
      {
        label: 'Sizzle Reels',
        text: 'Short promotional highlight videos',
        isCardSelected: false,
        value: 'sizzle_reel',
        Lengths: 'Lengths: typically up to 90 seconds',
      },
      {
        label: 'Editorials',
        text: 'Teaser videos meant to inform, educate, or entertain',
        isCardSelected: false,
        value: 'editorial',
        Lengths: 'Lengths: typically up to 90 seconds',
      },
      {
        label: 'Testimonials',
        text: 'Videos showcasing your clients to establish trust',
        isCardSelected: false,
        value: 'interviews',
        Lengths: 'Lengths: typically up to 90 seconds',
      },
    ],
  },
  {
    hero: 'What are your project needs?',
    key: 'basic_requirements',
    name: 'Basic Requirements',
    subtext: 'Select all that apply.',
    description: '',
    isMultiple: true,
    cardSelected: [],
    questionResponse: [],
    cards: [
      {
        label: 'Pre-production',
        text: 'Help with ideation, concepting and strategy ',
        isCardSelected: false,
        value: 'pre_production',
      },
      {
        label: 'Production',
        text: 'Live-action production shoot or virtual production shoot',
        isCardSelected: false,
        value: 'production',
      },
      {
        label: 'Animation',
        text: 'Original motion graphics',
        isCardSelected: false,
        value: 'animation',
      },
      {
        label: 'Video Editing',
        text:'Build from existing assets includig static, stills, digital renderings, TVC, long-form, UGC or upcoming shoot',
        isCardSelected: false,
        value: 'video_editing',
      },
    ],
  },
  {
    hero: 'Which style of animation do you prefer?',
    key: 'animation',
    name: 'Animation',
    description: '',
    isMultiple: false,
    cardSelected: [],
    questionResponse: [],
    cards: [
      {
        text: 'Motion Tracking',
        isCardSelected: false,
        imageUrl:
          'https://cdn.mos.cms.futurecdn.net/vChK6pTy3vN3KbYZ7UU7k3-320-80.jpg',
        value: 'motion_tracking',
      },
      {
        text: '3D Animation',
        isCardSelected: false,
        imageUrl:
          'https://cdn.mos.cms.futurecdn.net/vChK6pTy3vN3KbYZ7UU7k3-320-80.jpg',
        value: '3d_animation',
      },
      {
        text: 'Character/Cartoon-Based',
        isCardSelected: false,
        imageUrl:
          'https://cdn.mos.cms.futurecdn.net/vChK6pTy3vN3KbYZ7UU7k3-320-80.jpg',
        value: 'cartoon_based',
      },
      {
        text: 'Line Art',
        isCardSelected: false,
        imageUrl:
          'https://cdn.mos.cms.futurecdn.net/vChK6pTy3vN3KbYZ7UU7k3-320-80.jpg',
        value: 'line_art',
      },
      {
        text: 'Infographic',
        isCardSelected: false,
        imageUrl:
          'https://cdn.mos.cms.futurecdn.net/vChK6pTy3vN3KbYZ7UU7k3-320-80.jpg',
        value: 'infographic',
      },
      {
        text: 'Whiteboard',
        isCardSelected: false,
        imageUrl:
          'https://cdn.mos.cms.futurecdn.net/vChK6pTy3vN3KbYZ7UU7k3-320-80.jpg',
        value: 'whiteboard',
      },
      {
        text: 'Kinetic Text',
        isCardSelected: false,
        imageUrl:
          'https://cdn.mos.cms.futurecdn.net/vChK6pTy3vN3KbYZ7UU7k3-320-80.jpg',
        value: 'kinetic_text',
      },
      {
        text: '2D Vector',
        isCardSelected: false,
        imageUrl:
          'https://cdn.mos.cms.futurecdn.net/vChK6pTy3vN3KbYZ7UU7k3-320-80.jpg',
        value: '2d_vector',
      },
    ],
  },
  {
    hero: 'How long should the video be?',
    key: 'duration',
    name: 'Duration',
    description: '',
    isMultiple: false,
    cardSelected: [],
    questionResponse: [],
    cards: [
      {
        label: '15 seconds or less',
        text: 'Best for social ads',
        isCardSelected: false,
        value: 'less_15_seconds',
      },
      {
        label: '15-30 seconds',
        text: 'Instantly grab attention',
        isCardSelected: false,
        value: 'between_15_and_30_seconds',
      },
      {
        label: '30-60 seconds',
        text: 'Move from awareness to interest',
        isCardSelected: false,
        value: 'between_30_and_60_seconds',
      },
      {
        label: '1-5 minutes',
        text: 'Highlight product features or brand values',
        isCardSelected: false,
        value: 'between_60_and_300_seconds',
      },
      {
        label: 'Over 5 minutes',
        text: 'Storytelling, education, or interviews',
        isCardSelected: false,
        value: 'more_300_seconds',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/store/reducers/OnboardingRedesign/wizardInfo.js